import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { AppConfigService } from '../core/services/app-config.service';
import { DomSanitizer } from '@angular/platform-browser';
import { FormatConfigService } from '../core/services/format-config.service';
import { HttpClient } from '@angular/common/http';
import { Subscription } from 'rxjs';
import { TranslateNamePipe } from '../shared/pipes/simple/translate-name.pipe';
import { environment } from '../../environments/environment';
import { filter } from 'rxjs/operators';
import { NgTemplateOutlet } from '@angular/common';
import { LogoComponent } from '../shared/components/logo/logo.component';
import { RechteHinweisComponent } from './rechte-hinweis/rechte-hinweis.component';

@Component({
  templateUrl: 'dashboard.component.html',
  styleUrls: ['dashboard.component.scss'],
  imports: [NgTemplateOutlet, LogoComponent, RechteHinweisComponent, TranslatePipe]
})
export class DashboardComponent implements OnInit, OnDestroy, AfterViewInit {
  private spracheKanton;
  private kanton;

  dashboard: TemplateRef<any>;
  @ViewChild('internalDashboard', { static: true }) internalDashboardTemplate: TemplateRef<any>;
  @ViewChild('externalDashboard', { static: true }) externalDashboardTemplate: TemplateRef<any>;

  showExternalDashboard = false;

  externalUrl: string;

  deploymentMode: string;

  private subscription: Subscription = new Subscription();

  constructor(
    private translate: TranslateService,
    private formatConfigService: FormatConfigService,
    private translateName: TranslateNamePipe,
    private appConfigService: AppConfigService,
    private domSanitizer: DomSanitizer,
    private httpClient: HttpClient,
    private cd: ChangeDetectorRef
  ) {
    this.deploymentMode = environment.deploymentMode;
  }

  ngOnInit(): void {
    this.initDashboard();
    this.subscription.add(
      this.appConfigService.kanton$.subscribe((kanton) => {
        this.spracheKanton = this.translate.currentLang + '_' + kanton;
        this.kanton = kanton;
      })
    );
    this.subscription.add(
      this.translate.onLangChange.subscribe((lang) => {
        this.spracheKanton = lang.lang + '_' + this.kanton;
        this.initDashboard();
      })
    );
  }

  ngAfterViewInit() {
    this.cd.detectChanges();
  }

  private initDashboard() {
    this.subscription.add(
      this.formatConfigService.settingsConfig$.pipe(filter((settingsConfig) => !!settingsConfig)).subscribe((settingsConfig) => {
        this.externalUrl = this.extractFrom(settingsConfig.externalStartseiteUrl);
        if (this.externalUrl) {
          this.setToExternalDashboardIfUrlAvailable(this.externalUrl);
        } else {
          this.dashboard = this.internalDashboardTemplate;
        }
        this.cd.detectChanges();
      })
    );
  }

  private extractFrom(configuredExternalUrl): string {
    if (configuredExternalUrl) {
      return this.translateName.transform(configuredExternalUrl);
    }
    return null;
  }

  private setToExternalDashboardIfUrlAvailable(url) {
    this.httpClient.get(url).subscribe({
      next: () => {
        this.dashboard = this.externalDashboardTemplate;
      },
      error: (err) => {
        if (err.status !== 404) {
          this.dashboard = this.externalDashboardTemplate;
          return;
        }
        this.dashboard = this.internalDashboardTemplate;
      }
    });
  }

  cleanURL(oldURL: string) {
    return this.domSanitizer.bypassSecurityTrustResourceUrl(oldURL);
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
